module.exports = __webpack_public_path__ + "img/apply_bg1.5ad9bc95.png";